<template>
  <b-card no-body class="mb-1" v-if="currentUser.info.role_id === 3 || currentUser.info.role_id === 4 || currentUser.info.role_id === 6">
    <b-card-header header-tag="header" class="p-3" role="tab">
      <span class="m-1">Akun Bank</span>
      <b-button v-b-toggle.accordion-7 variant="yellow" class="chevron">
        <span class="when-open">
          <b-icon icon="chevron-up" />
        </span>
        <span class="when-closed">
          <b-icon icon="chevron-down" />
        </span>
      </b-button>
    </b-card-header>

    <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <div class="container">
            <b-form @submit.prevent="saveBankAccount">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="bank_name">Nama Bank *</label>
                    <v-select 
                      v-model="bankAccount.bank_id" 
                      :options="bankOptions" 
                      :reduce="bank => bank.value" 
                      label="text"
                      placeholder="Pilih bank..."
                      reqiured
                      disabled
                    ></v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="account_number">Nomor Rekening *</label>
                    <b-form-input v-model="bankAccount.account_number" placeholder="Masukkan nomor rekening" readOnly></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="account_name">Nama Pemilik Rekening *</label>
                    <b-form-input v-model="bankAccount.account_name" placeholder="Masukkan nama pemilik rekening" readOnly></b-form-input>
                  </div>
                </div>
              </div>
            </b-form>
          </div>

          <!-- Modal konfirmasi -->
          <b-modal size="sm" v-model="confirmModal" hide-footer hide-header>
            <div class="d-block text-center">
              <h3>Apakah Anda yakin ingin menyimpan data ini?</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="confirmSaveBankAccount">Ya</b-button>
              </div>
              <div class="col">
                <b-button class="mt-3" block @click="confirmModal = false">Tidak</b-button>
              </div>
            </div>
          </b-modal>

          <!-- Modal sukses -->
          <b-modal size="sm" v-model="successModal" hide-footer hide-header>
            <div class="d-block text-center">
              <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
              <h3>Data akun bank berhasil disimpan!</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
              </div>
            </div>
          </b-modal>

          <b-modal size="sm" v-model="errorModal" hide-footer hide-header>
            <div class="d-block text-center">
              <b-icon 
                icon="x-circle" 
                animation="throb" 
                variant="danger" 
                style="width: 120px; height: 120px;">
              </b-icon>
              <h3>Data akun bank gagal disimpan!</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block variant="danger" @click="errorModal = false">
                  Tutup
                </b-button>
              </div>
            </div>
          </b-modal>
        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>


<script>
import JenisBank from "../../api/jenisbank";
import UserBank from "../../api/userbank";

export default {
  name: "AkunBankAgency",
  data() {
    return {
      bankAccount: {
        id: null,
        bank_id: null,
        account_number: "",
        account_name: "",
      },
      bankOptions: [],
      confirmModal: false,
      successModal: false,
      errorModal: false,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    loadData() {
      UserBank.me()
        .then((res) => {
          this.bankAccount.id = res.data.data.id;

          if (res.data.data.bank_id) {
            this.bankAccount.bank_id = res.data.data.bank_id;
          }
          if (res.data.data.account_number) {
            this.bankAccount.account_number = res.data.data.account_number;
          }
          if (res.data.data.account_name) {
            this.bankAccount.account_name = res.data.data.account_name;
          }
          JenisBank.index()
            .then((res) => {
              // console.log(res);
              this.bankOptions = res.data.data.map(bank => ({
                value: bank.id,
                text: bank.name
              }));
            })
            .catch((err) => console.log(err));
        })
        .catch(err => console.log(err));
    },
    saveBankAccount() {
      this.confirmModal = true;
    },
    confirmSaveBankAccount() {
      UserBank.update(this.bankAccount)
        .then(res => {
          console.log(res);
          if (res.data.meta.code === 200 || res.data.meta.code === 201) {
            this.successModal = true;
            this.confirmModal = false;
          } else {
            this.errorModal = true;
            this.confirmModal = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.confirmModal = false;
        });
    }
  }
};
</script>


<style scoped>
.collapsed>.when-open,
.not-collapsed>.when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/AkunBankAgency.vue